<template>
  <ds-dialog :id="id" :show="show" :title="title" @close="cancel">
    <p v-if="body">{{ body }}</p>
    <slot />

    <template #footer>
      <ds-button variant="text" :data-qa="`${id}-cancel`" @click="cancel">
        {{ cancelLabel || i18n.t('/common/cancel') }}
      </ds-button>
      <ds-button
        :variant="danger ? 'danger' : 'primary'"
        :disabled="confirmDisabled"
        :data-qa="`${id}-confirm`"
        @click="$emit('confirm')"
      >
        <ds-icon v-if="showTrashIcon" name="trash" />
        {{ confirmLabel || i18n.t('/common/confirm') }}
      </ds-button>
    </template>
  </ds-dialog>
</template>

<script>
import DsDialog from '@/components/ds/molecules/dsDialog/DsDialog.vue'
import DsButton from '@/components/ds/atoms/dsButton/DsButton.vue'
import DsIcon from '@/components/ds/atoms/dsIcon/DsIcon.vue'

// A confirm/cancel dialog on the shared DsDialog shell.
//
// There are exactly two outcomes: `confirm`, or `cancel`. Every way of
// dismissing the dialog — Escape, the backdrop, the close button — emits
// `cancel`, so a caller never has to wire the same handler up twice.

export default {
  name: 'DsConfirmDialog',
  components: { DsDialog, DsButton, DsIcon },
  props: {
    id: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: null,
    },
    cancelLabel: {
      type: String,
      default: null,
    },
    confirmDisabled: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    // A confirm button that deletes leads with the trash glyph, matching the
    // design's shared ConfirmDialog (admin-ui.jsx: /verwijder/i on the label).
    showTrashIcon() {
      return !this.confirmDisabled && /verwijder/i.test(this.confirmLabel || '')
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
